<template>
    <div>
        <el-form ref="searcherForm" :model="searcherForm" label-width="80px" :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="名称">
                <el-input v-model="searcherForm.name"></el-input>
            </el-form-item>
            <el-form-item >
                <el-button type="primary" plain>搜索</el-button>
                <el-button   plain @click="PurchaseInventory()">入库</el-button>
                <el-button   plain @click="PurchaseOutbound()">出库</el-button>
            </el-form-item>
        </el-form>

        <!-- 入库组件 -->
        <store @closeDialog="closeDialog" :dialogShowIn="dialogShowIn" :dialogShowOut="dialogShowOut"  ></store>
    </div>
</template>

<script>
import store from '@/components/store.vue'

export default {
    components:{
        store
    },
     data() {
        return {
            searcherForm: {
                name: ''
            },
            dialogShowIn:false, // 弹窗控制
            dialogShowOut:false, // 弹窗控制
        }
     },
    methods: {
        // 采购入库
        PurchaseInventory(){
            this.dialogShowIn = true;
        },
        PurchaseOutbound(){
            this.dialogShowOut = true;
        },
        async closeDialog(data){
            this.dialogShowIn = data;
            this.dialogShowOut = data;
        },
    },
    created() {

    },
    mounted() {

    }
}
</script>
<style lang="css" scoped>

</style>